import { FC } from 'react';
import { Section } from './ui/Section';
import type { Skill } from '../types/cv';

interface Props {
  skills: Skill[];
  title?: string;
}

/**
 * One text run per group rather than one chip per keyword. Denser on the page,
 * and it comes out of the PDF as a readable sentence rather than a column of
 * single words.
 */
export const Skills: FC<Props> = ({ skills, title = 'Skills' }) => (
  <Section title={title}>
    {skills.map((group, i) => (
      <div className="cv-skill-group" key={`${group.name}-${i}`}>
        {group.name && (
          <h3 className="cv-skill-name">
            {group.name}
            {group.level && <span className="cv-skill-level"> ({group.level})</span>}
          </h3>
        )}
        {group.keywords && group.keywords.length > 0 && (
          <p className="cv-skill-keywords">{group.keywords.join(' · ')}</p>
        )}
        {group.summary && <p className="cv-skill-keywords">{group.summary}</p>}
      </div>
    ))}
  </Section>
);

export default Skills;
